const themeTableViewHg = () => import('@/views/main/dataList/themeTableViewHg.vue')
export default {
  path: '/main/dataList/themeTableViewHg/:id',
  name: 'themeTableViewHg',
  component: themeTableViewHg,
  children: []
}
